import { render } from "./GenerateMessageHouse.vue?vue&type=template&id=61e54e4c&scoped=true"
import script from "./GenerateMessageHouse.vue?vue&type=script&lang=js"
export * from "./GenerateMessageHouse.vue?vue&type=script&lang=js"

import "./GenerateMessageHouse.vue?vue&type=style&index=0&id=61e54e4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e54e4c"]])

export default __exports__